import { render } from "./LicenseTab.vue?vue&type=template&id=0b127636&scoped=true&ts=true"
import script from "./LicenseTab.vue?vue&type=script&lang=ts"
export * from "./LicenseTab.vue?vue&type=script&lang=ts"

import "./LicenseTab.vue?vue&type=style&index=0&id=0b127636&scoped=true&lang=css"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b127636"]])

export default __exports__